export const MODAL_DIALOG__EDIT_SEO_TRANSLATIONS = 'MODAL_DIALOG__EDIT_SEO_TRANSLATIONS';
export const MODAL_DIALOG__CREATE_CUSTOM_TAG = 'MODAL_DIALOG__CREATE_CUSTOM_TAG';
